import { render } from "./TechinicalKnowledgeRow.vue?vue&type=template&id=cf4784bc&ts=true"
import script from "./TechinicalKnowledgeRow.vue?vue&type=script&lang=ts"
export * from "./TechinicalKnowledgeRow.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__